import "./OrganizationServices.module.css";
import Header from "@/reusable_sections/Header";
import LayananOrganisasiHero from "./sections/LayananOrganisasiHero";
import OrganizationalServicesGrid from "./sections/OrganizationalServicesGrid";
import ServiceBenefitsGrid from "./sections/ServiceBenefitsGrid";
import Footer from "@/reusable_sections/Footer";
export default function OrganizationServicesPage() {
  return <div>
      <Header />
      <LayananOrganisasiHero />
      <OrganizationalServicesGrid />
      <ServiceBenefitsGrid />
      <Footer />
    </div>;
}